import React from 'react'
import AssetLimitsModal from '~modals/AssetLimitsModal'
import LocaleModal from '~modals/LocaleModal'
import MigrationModal from '~modals/MigrationModal'
import ReferralModal from '~modals/ReferralModal'
import SettingsModal from '~modals/SettingsModal'
import SocialReferralModal from '~modals/SocialReferralModal'
import StakingModal from '~modals/StakingModal'
import TransactionDetailsModal from '~modals/TransactionDetailsModal'
import WalletIdModal from '~modals/WalletIdModal'
import CardTransactionModal from '~modals/CardTransactionModal'

interface Props {
    showStaking?: boolean
    showReferral?: boolean
}

function GlobalModalsContainer({ showStaking, showReferral }: Props) {
    return (
        <>
            <CardTransactionModal />
            <LocaleModal />
            <SettingsModal />
            <WalletIdModal />
            <MigrationModal />
            <AssetLimitsModal />
            <SocialReferralModal />
            <TransactionDetailsModal />
            {showStaking && <StakingModal />}
            {showReferral && <ReferralModal />}
        </>
    )
}

export default GlobalModalsContainer
